import React from 'react'
import NewTopNavBar from './NewTopNavBar'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';

const TranscriptMain = () => {
    const navigate = useNavigate();
    return (
        <div>
            <div>
                <NewTopNavBar />
                <div className='text-center pt-5'>
                    <Button disabled onClick={() => {
                        navigate("/youtube-video-transcript");
                    }}>Youtube Link</Button>
                    <Button onClick={() => {
                        navigate("/video-transcript");
                    }}>Video File</Button>
                </div>
            </div>
        </div>
    )
}

export default TranscriptMain